import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import { MCRow } from '../components';

const List = styled.div`
  height: auto;
  overflow: scroll;
`;

const MCList = ({ theme, coins }) => (
  <ThemeProvider theme={theme}>
    <List>{coins.map(coin => <MCRow coin={coin} key={coin.id} />)}</List>
  </ThemeProvider>
);

export default withTheme(MCList);



// WEBPACK FOOTER //
// ./src/components/MCList.js